import React, { memo } from "react";
import { MenuItem, MenuItemProps } from "@mui/material";

const AppMenuItem = ({ sx, ...otherProps }: MenuItemProps) => {
  return (
    <MenuItem
      sx={{
        "&.Mui-selected": {
          color: "primary.main",
          fontWeight: 500,
        },
        "&:hover": {
          color: "primary.main",
          backgroundColor: "transparent",
        },
        ...sx,
      }}
      {...otherProps}
    />
  );
};

export default memo(AppMenuItem);
